export default "__VITE_ASSET__327e7e4a__"